import {
  Box,
  Center,
  Flex,
  Grid,
  Skeleton,
  SkeletonText,
} from "@chakra-ui/react";
import React from "react";

const ServicePricingSkeleton = () => {
  return (
    <Grid
      sx={{
        padding: "30px 10px",
        border: "1px solid #dae0ea",
        borderRadius: "4px",
        bg: "white",
        marginBottom: "30px",
      }}
      templateRows="auto 1fr"
    >
      <Box mx="auto">
        <Center>
          <Skeleton height={4} width="80px" />
        </Center>
        <Center my="9">
          <Skeleton sx={{ borderRadius: "8px" }} height={150} width={150} />
        </Center>
      </Box>

      <Grid>
        <SkeletonText px={8} mt="4" noOfLines={6} spacing="8" />

        <Flex
          mt="16"
          justify="center"
          sx={{ alignSelf: "flex-end", flexDirection: "column" }}
        >
          <Skeleton
            height={30}
            width="100%"
            sx={{
              py: "6",
              mt: "5",
              borderRadius: "100px",
            }}
          />
        </Flex>
      </Grid>
    </Grid>
  );
};

export default ServicePricingSkeleton;
